import { useContext } from 'react';

import { WantedProductTemplatesContext } from 'search/providers/WantedProductTemplatesProvider';

export const useWantedProductTemplates = () => useContext(WantedProductTemplatesContext);
